import getHostVariables from './getHostVariables';
import {ANCESTOR_ROOT_NODE} from '../symbols';
import {ACTIVE_SPAN} from '@servicenow/ui-internal';

export function getActiveSpan(host) {
	if (!host) return;
	const hostVariables = getHostVariables(host);
	if (!hostVariables[ANCESTOR_ROOT_NODE]) return;
	return hostVariables[ANCESTOR_ROOT_NODE][ACTIVE_SPAN];
}
